var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXianhezai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687",
    d: "M4.25 1.8125L4.25 11.7105",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13",
    d: "M4.24993 13.0521L2.46369 11.0397L6.03617 11.0397L4.24993 13.0521Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687_2",
    d: "M8.75 1.8125L8.75 11.7105",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13_2",
    d: "M8.74993 13.0521L6.96369 11.0397L10.5362 11.0397L8.74993 13.0521Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687_3",
    d: "M13.25 1.8125L13.25 11.7105",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13_3",
    d: "M13.2499 13.0521L11.4637 11.0397L15.0362 11.0397L13.2499 13.0521Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 699",
    d: "M1.09375 13.625H16.4062",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXianhezai);
export default __webpack_public_path__ + "static/media/xianhezai.d225533161ac90cfaddf59fee9a1beb3.svg";
export { ForwardRef as ReactComponent };